import { RESTRICTION_WRITE_ROLES } from '@/core/components/sites/site/restrictions/restriction-filters'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/restrictions/create/'
)({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (!RESTRICTION_WRITE_ROLES.includes(auth.user?.role ?? '')) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
})
